import React from 'react';
import { ChevronRightIcon } from '../assets/icons';
import { classNames } from '../utils';

class Pagination extends React.Component {

	onClick = (e, page) => {
		e.preventDefault();
		if (this.props.onChange && typeof page === 'number')
			this.props.onChange(page);
	}

	prev = (e) => {
		e.preventDefault();
		this.props.onChange(this.props.active - 1);
	}

	next = (e) => {
		e.preventDefault();
		this.props.onChange(this.props.active + 1);
	}

	getPages() {
		var current = this.props.active,
			last = this.props.pages,
			delta = 1,
			left = current - delta,
			right = current + delta + 1,
			range = [],
			rangeWithDots = [],
			l;

	    for (let i = 1; i <= last; i++) {
	        if ((i === 1 || i === last) || (i >= left && i < right)) {
	            range.push(i);
	        }
	    }

	    for (let i of range) {
	        if (l) {
	            if (i - l === 2) {
	                rangeWithDots.push(l + 1);
	            } else if (i - l !== 1) {
	                rangeWithDots.push('...');
	            }
	        }
	        rangeWithDots.push(i);
	        l = i;
	    }

		let pages = [];
		for (let i = 0; i < rangeWithDots.length; i++) {
			pages.push(
				<button
					key={ i }
					className={classNames('h-8 w-8 flex items-center justify-center text-sm font-medium border rounded-md hover:bg-red/10 hover:border-red/10', this.props.active === rangeWithDots[i] ? 'border-red text-red' : ' border-gray6 text-text')}
					onClick={e => this.onClick(e,rangeWithDots[i])}
				>
					{ rangeWithDots[i] }
				</button>
			)
		}
		return pages;
	}

	render() {
		if (this.props.pages > 1) {
			return (
				<div className="flex items-center gap-1">
					<button className="h-8 w-8 p-2 hover:bg-gray5 rounded-md border border-gray6" disabled={ this.props.active === 1 } onClick={ this.prev }>
						<img src={ChevronRightIcon} className="w-3 h-3 object-contain rotate-180" alt="" />
					</button>
					{ this.getPages() }
					<button className="h-8 w-8 p-2 hover:bg-gray5 rounded-md border border-gray6" disabled={this.props.active === this.props.pages} onClick={ this.next }>
						<img src={ChevronRightIcon} className="w-3 h-3 object-contain" alt="" />
					</button>
				</div>
			)
		}
		else {
			return null;
		}
	}
}

export default Pagination;